import  { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';

import Hosts from '../../../Hosts';
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,

	pattern_vat,
	pattern_email,
	passwordHash,

} from '../../../Utils';

import { language } from './Language';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const dadosEntidades = useRef([]);

	const [lang, /*set_lang*/] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)

	const entity_types = [
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	const [selectedUserTypeId, setSelectedUserTypeId] = useState('');
	const [selectedDepartamentId, setSelectedDepartamentId] = useState('');

	const [userTypes, setUserTypes] = useState([]);
	const [userDepartament, setUserDepartament] = useState([]);
	const [colaboradores, setColaboradores] = useState([]);
	const [selectedResponsaveis, setSelectedResponsaveis] = useState([]);
	const [nomeDepartamento, setNomeDepartamento] = useState('');
	const [departamentoSelecionado, setDepartamentoSelecionado] = useState([])
	const [departamentos, setDepartamentos] = useState([])

	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const change_identification_type = e => {
		set_dados(dados.current.info.identification.tipo_identificacao = e.value);
	}

	/*const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return } 
				//alert('Distrito não encontrado!')
			)
	}*/

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				set_dados(dados.current = res.data[0]);
				//console.log(res)

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}

	// const handleCheckboxChange = (responsavelId) => {
	// 	setSelectedResponsaveis((prevState) =>
	// 		prevState.includes(responsavelId)
	// 			? prevState.filter((id) => id !== responsavelId) // Remove se já estiver selecionado
	// 			: [...prevState, responsavelId] // Adiciona se não estiver selecionado
	// 	);
	// };

	// const adicionarDepartamento = (nomeDepartamento, responsaveisSelecionados, colaboradores) => {
	// 	set_dados((dadosAnteriores) => {
	// 		const responsaveisValidos = Array.isArray(responsaveisSelecionados) ? responsaveisSelecionados : [];

	// 		const novoDepartamento = {
	// 			id: Date.now().toString(),
	// 			nome: nomeDepartamento,
	// 			responsaveis: responsaveisValidos.map((id) => {
	// 				const responsavel = colaboradores.find((colaborador) => colaborador.value === id);
	// 				return { id: responsavel.value, nome: responsavel.label };
	// 			})
	// 		};

	// 		const departamentosAtualizados = Array.isArray(dadosAnteriores.departamento)
	// 			? [...dadosAnteriores.departamento, novoDepartamento]
	// 			: [novoDepartamento];

	// 		dados.current.info.departamento = novoDepartamento
	// 		dados.current.info.departamento = departamentosAtualizados;
	// 		setNomeDepartamento('')
	// 		setSelectedResponsaveis('')

	// 		// console.log("Dados da empresa", dados)
	// 		return {
	// 			...dadosAnteriores,
	// 			departamento: departamentosAtualizados
	// 		};
	// 	});
	// };

	// const fetch_colaboradores = async () => {
	// 	try {
	// 		const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Colaborador');
	// 		const colaboradoresOptions = res.data.map(colaborador => ({
	// 			label: colaborador.name,
	// 			value: colaborador.id
	// 		}));
	// 		setColaboradores(colaboradoresOptions);
	// 		// console.log("colaboradores:", colaboradoresOptions)
	// 	} catch (error) {
	// 		// console.error("Erro ao buscar os colaboradores:", error);
	// 	}
	// };

	// const handleUserTypeChange = (e) => {
	// 	const selectedValue = e.target.value;
	// 	setSelectedUserTypeId(selectedValue);  // tipo de utilizador escolhido
	// 	// console.log("Escolhi o utilizador", selectedValue)
	// 	set_dados(dados.current.profile.name = selectedValue);
	// };

	// const handleUserDepartamentChange = (e) => {
	// 	const selectedDepartament = e.target.value;
	// 	setSelectedDepartamentId(selectedDepartament);
	// 	// console.log("Selected department:", selectedDepartament);
	// 	set_dados(dados.current.info.departamento = selectedDepartament);
	// };
	
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props

	// função para redirecionar o utilizador para a página de detalhes da entidade
	// const handleNavigate = () => {
	// 	// history.push('https://web403.assec.net/dev/genuine/website-gest/entidade02_detalhesEntidade'); // redireciona o utilizador para a nova página
	// 	history.push('/entidade02_detalhesEntidade'); // redireciona o utilizador para a nova página
	//   };

	// BIA
	// função para ir buscar as entidades ao servidor 
	useEffect(() => {
		async function fetchEntities() {
			try {
				const res = await reqGET(Hosts.SIMCore_API + '/entities/list/' + getTokenInfo().companycode + '/Entidade02'); //caminho para a API
				
				// verifico se a resposta é válida
				if (!res || res.status !== 200) {
					throw new Error(`Erro ao ir a buscar as entidades: ${res.statusText || 'Sem resposta'}`);
				}
	
				const result = res.data; // acedo ao body dos dados da resposta
				set_dados(dadosEntidades.current = result); // atualizo o estado com as entidades recebidas
				// console.log(dadosEntidades.current); // 
	
			} catch (error) {
				console.error("Erro ao ir a buscar as entidades:", error); 
			}
		}
	
		fetchEntities();
	}, []);
	

	// useEffect(() => {
	// 	// Vai buscar o tipo de utilizador
	// 	const fetch_tipo_utilizadores = async () => {
	// 		try {

				// const res = await reqGET('https://web403.assec.net/api/simnet_genuine_website/profiles/' + getTokenInfo().companycode);
	// 			setUserTypes(res.data); // Armazena os tipos de utilizadores no estado
	// 			// console.log("Tipos de utilizador", res.data)
	// 		} catch (error) {
	// 			// console.error("Erro ao buscar os tipos de utilizadores:", error);
	// 		}
	// 	};


	// 	const fetch_departamentos = async () => {
	// 		try {
	// 			const res = await reqGET('https://web403.assec.net/api/simnet_genuine_website/intranet/departments/' + getTokenInfo().companycode);
	// 			setUserDepartament(res.data);
	// 			// console.log("Departamentos", res.data)
	// 		} catch (error) {
	// 			// console.error("Erro ao buscar os tipos de utilizadores:", error);
	// 		}
	// 	};

	// 	const fetch_departamentos_1 = async () => {
	// 		try {
	// 			const res = await reqGET('https://web403.assec.net/api/simnet_genuine_website/intranet/departments/' + getTokenInfo().companycode);
	// 			const departamentoOptions = res.data.map(departamento => ({
	// 				id: departamento.id,
	// 				name: departamento.info.name
	// 			}));
	// 			setDepartamentos(departamentoOptions);;
	// 			// console.log("Departamentos na res ", res.data)
	// 			// console.log("Departamentos  no state", departamentos)
	// 		} catch (error) {
	// 			console.error("Erro ao buscar os tipos de utilizadores:", error);
	// 		}
	// 	};
	// 	fetch_departamentos_1();
	// 	fetch_departamentos();
	// 	fetch_tipo_utilizadores();
	// 	fetch_colaboradores();
	// }, []);

	// useEffect(() => {
	// 	console.log("Departamentos no state atualizado:", departamentos);
	// }, [departamentos]);

	/* useEffect(() => {
		// Vai buscar o tipo de utilizador
		const fetch_empresas = async () => {
			try {
				const res = await reqGET('https://web403.assec.net/dev/genuine/website-gest/entidade_list' + getTokenInfo());
				const dados = (res.data); // Armazena os tipos de utilizadores no estado
				console.log("Dados das entidades:", dados)
			} catch (error) {
				console.error("Erro ao buscar os tipos de utilizadores:", error);
			}
		};
	
		fetch_empresas();
	}, []);
	*/
	
	useEffect(() => {

		clean_data();
		obter_paises_em_pt(set_countries);

		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				// console.log('000', props.location.state.item['id'])

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		}
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								// props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})
		}
	}

	/*const handleSubmitVat = async e => {
		e.preventDefault();
	
		setLoading(true);
		get_vat_info(dados.current.info.vat)
			.then(res => {
				//console.log('---------- VAT INFO --------------')
				//console.log(res)
	
				if ((res.data.name !== '---') && (res.data.name !== '')) {
					clean_data();
					set_dados(dados.current.info.vat = res.data.vatNumber);
					set_dados(dados.current.info.name = res.data.name);
					set_dados(dados.current.addresses[0].address_detail = res.data.address);
	
					let aMorada = res.data.address.split("\n");
					// Verificar se pais é PT
					if (res.data.countryCode === 'pt') {
						//console.log('----------------------> É PT')
	
						change_country({ value: 'Portugal' })
	
	
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
	
						let city = aMorada[1];
						if (city !== undefined) {
							city = city.toLowerCase();
							city = city.charAt(0).toUpperCase() + city.slice(1);
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))
	
	
							// After District -> City
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))
	
							let aMoradaCP = aMorada[2].split(" ");
							set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
						}
					} else {
						//console.log('---------------------->NÃO È PT')
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
					}
				}
				else {
	
					Swal.fire('VAT não encotrado na base VIES.', '', 'info')
	
				}
				setLoading(false)
			})
	
			.catch(error => { setLoading(false); alert(error) });
	}*/

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							/* alert(res.status === 200 ?
								'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};

	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)
		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info.identificacao[name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	
	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">

						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
													</div>

													{/* Tipo de Utilizador Section */}
													{/* <div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">Tipo de Entidade</label>
														<select
															name="user_type"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															onChange={handleUserTypeChange}
															value={dados.current.profile.name}
														>
															{userTypes.map((userType) => (
																<option key={userType.name} data-qwerty={"blabbahahha"} value={userType.name}>
																	{userType.name}
																</option>
															))}
														</select> */}

														{/* mostra os tipos de utilizadores como JSON na página */}
   															{/* <pre>{JSON.stringify(userTypes, null, 2)}</pre> */}
													{/* </div> */}

													{/* <div className="col-md-3 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].type}</label>

														<Select
															className="div-select"
															options={entity_types}
															name="client_type"
															value={dados.current.info.entity_type === '' ? null : { label: dados.current.info.entity_type, value: dados.current.info.entity_type }}
															placeholder={language[lang].type_placeholder}
															onChange={change_entity_type}
															styles={custom_select_styles}
														/>
													</div> */}

												</div>

												{/*
												<div className="row mb-5 d-none">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].type_identification}</label>
														
														<Select
															className="div-select"
															options={identification_types}
															name="identification_type"
															value={dados.current.info.identification.tipo_identificacao === '' ? null : { label: dados.current.info.identification.tipo_identificacao, value: dados.current.info.identification.tipo_identificacao }}
															placeholder={language[lang].type_identification_placeholder}
															onChange={change_identification_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_number}</label>
														<input type="text" pattern="\d*" inputMode='numeric' maxLength="11" name="numero_identificacao" value={dados.current.info.identification.numero_identificacao} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].identification_number_placeholder} onChange={handle_change_info_identification} />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_validation}</label>
														<input type="date" name="validade_identificacao" value={dados.current.info.identification.validade_identificacao !== '' ? dados.current.info.identification.validade_identificacao : ''} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info_identification} /> 
													</div>
												</div>
												*/}

												<div className="row mb-5">
													{/* <div className="col-md-4 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].tlf}</label>

														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlf_placeholder}
															value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
															onChange={e => set_dados(dados.current.contacts[0].phone = e)}
														/>
													</div> */}

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].tlm}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlm_placeholder}
															value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
															onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
														/>

													
													</div>
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">Data de Abertura da Ficha</label>
														<input type="date"  name="dataAberturaFicha" value={dados.current.info.dataAberturaFicha != undefined && dados.current.info.dataAberturaFicha != '' ? dados.current.info.dataAberturaFicha : dados.current.contacts[0].dataAberturaFicha} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info} />
													</div>

													{/* o código do birthday não está a funcionar */}
													{/* <div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].birthday}</label>
														<input type="date" name="birthday" value={dados.current.info.birthday !== '' ? dados.current.info.birthday : ''} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info} />
													</div> */}

													{/* <div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">Departamento</label>
														<select
															name="departamento"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															onChange={handleUserDepartamentChange}
															value={dados.current?.info?.departamento || ""}
														>
															{userDepartament.map((departamento) => (
																<option key={departamento.id} value={departamento.info.name}>
																	{departamento.info.name}
																</option>
															))}
														</select>
													</div> */}
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].vat}</label>
														<input type="text" pattern={pattern_vat} minLength="9" inputMode='numeric' name="vat" value={dados.current.info.vat} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].vat_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].district}</label>
														<Select
															className="div-select"
															options={districts}
															name="distrito"
															value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
															placeholder={language[lang].district_placeholder}
															onChange={change_district}
															styles={custom_select_styles}
														/>
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].city}</label>
														<Select
															className="div-select"
															options={cities}
															name="concelho"
															value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
															placeholder={language[lang].city_placeholder}
															onChange={change_city}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].village}</label>
														<Select
															className="div-select"
															options={villages}
															name="freguesia"
															value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
															placeholder={language[lang].village_placeholder}
															onChange={change_village}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].local}</label>
														<input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />

													</div>

												</div>

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].morada}</label>
														<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].postal_code}</label>
														<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
													</div>



														<div>
															<label className="fs-5 fw-bold mt-5">Detalhes da Entidade</label>
																<table className="table table-bordered text-center my-5">
																	<thead>
																		<tr className="table-success">
																			<th scope="col"><strong>Domínio</strong></th>
																			<th scope="col"><strong>SSL</strong></th>
																			<th scope="col"><strong>GD</strong></th>
																			{/* <th scope="col"><strong>Email</strong></th> */}
																			<th scope="col"><strong>Site</strong></th>
																			<th scope="col"><strong>Obs</strong></th>
																		</tr>
																	</thead>
																	<tbody>
																		<tr>
																			<td> <input type="text"  className="form-control"  name="nameDominio" value={dados.current.info.nameDominio} onChange={handle_change_info} /></td>
																			<td> <input type="text"  className="form-control"  name="ssl" value={dados.current.info.ssl} onChange={handle_change_info} /></td>
																			<td> <input type="text"  className="form-control"  name="gd" value={dados.current.info.gd} onChange={handle_change_info}/></td>
																			{/* <td> <input type="text"  className="form-control"  name="" value={dados.current.info.} onChange={handle_change_info}/> </td> */}
																			<td> <input type="text"   className="form-control"  name="site" value={dados.current.info.site} onChange={handle_change_info} /></td>
																			<td> <input type="text"  className="form-control"  name="obs" value={dados.current.info.obs} onChange={handle_change_info}/></td>
																		</tr>
																	</tbody>
																</table>
														</div>
															{/* DELETE CODE */}
													{/* /////////// */}
													{/* <div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">Departamento</label>
														<select
															name="departamento"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															onChange={escolheDepartamentos} 
															value={departamentoSelecionado || []} 
															multiple 
														>
															{departamentos.length > 0 ? (
																departamentos.map((departamento) => (
																	<option key={departamento.id} value={departamento.id}>
																		{departamento.name} 
																	</option>
																))
															) : (
																<option disabled>Carregando departamentos...</option> 
															)}
														</select>
													</div> */}
													{/* /////////// */}

													{/* {dados.current.profile.name === 'Empresa' && (
														<div className="col-md-6">
															<label className="fs-5 fw-bold mb-2">Inserir Departamentos</label>
															<input
																type="text"
																className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
																placeholder="Nome do Departamento"
																value={nomeDepartamento}
																onChange={(e) => setNomeDepartamento(e.target.value)}
															/>

															<div style={{ marginTop: '5%', marginBottom: '5%' }}>
																<label className="fs-5 fw-bold mb-2">Responsáveis:</label>
																<div>
																	{colaboradores.length > 0 ? (
																		colaboradores.map((colaborador) => (
																			<div key={colaborador.value} style={{ marginBottom: '10px' }}>
																				<label style={{ display: 'flex', alignItems: 'center' }}>
																					<input
																						type="checkbox"
																						value={colaborador.value}
																						checked={selectedResponsaveis.includes(colaborador.value)}
																						onChange={() => handleCheckboxChange(colaborador.value)}
																						style={{ marginRight: '10px' }}
																					/>
																					{colaborador.label}
																				</label>
																			</div>
																		))
																	) : (
																		<p style={{ color: '#999' }}>Carregando colaboradores...</p>
																	)}
																</div>
															</div>

															{selectedResponsaveis.length > 0 && (
																<div>
																	<h4 className="fs-5 fw-bold mb-2">Responsáveis Selecionados:</h4>
																	<ul style={{ listStyle: 'none', paddingLeft: '0' }}>
																		{selectedResponsaveis.map(responsavelId => {
																			const responsavel = colaboradores.find(col => col.value === responsavelId);
																			return <li key={responsavelId} style={{ padding: '5px 0' }}>{responsavel?.label}</li>;
																		})}
																	</ul>
																</div>
															)}

															<div style={{ textAlign: 'end', marginTop: '5%' }}>
																<button
																	onClick={() => adicionarDepartamento(nomeDepartamento, selectedResponsaveis, colaboradores)}
																	className="btn btn-default"
																	style={{ display: 'inline-block', padding: '10px 20px', fontSize: '15px' }}
																>
																	Adicionar Departamento
																</button>
															</div>
														</div>
													)} */}
												</div>

											</div>
											{/*  se for empresa vai apresentar então a possibilidade de adicionar grupos de pessoas(departamentos) */}
										</form>
									</div>
								</div>

								{/* entidades já criadas */}
								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_ver_editar">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">Entidades já criadas</h3>
										</div>
									</div>
									<div id="div_entidade_ver_editar" className="collapse show">
										<form id="form_ver_editar">
											<div className="card-body border-top p-4">
											{/* verifico se há entidades em dadosEntidades.current e renderizo-as */}
											{dadosEntidades.current && dadosEntidades.current.length > 0 ? (
												<>
												{/* {console.log("Entidades carregadas:", dadosEntidades.current)} */}
												{dadosEntidades.current.map((entidade, index) => (
													<div key={index} className="mb-3">
													{/*  navegar para o componente DetalhesEntidade */}
															<Link key={index}
																	to={`/entidade02_detalhesEntidade/${entidade.id}`}
																	className="btn btn-primary"
																>
																<div> {entidade.name} </div>
															</Link>

													</div>
												))}
												</>
											) : (
												<p>Nenhuma entidade criada :( </p>
											)}
											</div>
										</form>
										</div>

								</div>



												{/* Dados de Login */}
								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form_user" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form_user" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
